/**
 * Element tag constants for different types of interactive elements
 */
export const ElementTag = {
    CLICKABLE: "CLICKABLE",
    FILLABLE: "FILLABLE",
    SELECTABLE: "SELECTABLE",
    NON_INTERACTIVE_ELEMENT: 'NON_INTERACTIVE_ELEMENT',
};
//# sourceMappingURL=ElementTag.js.map